import { render, staticRenderFns } from "./programadoAtendido.vue?vue&type=template&id=04747980"
import script from "./programadoAtendido.vue?vue&type=script&lang=js"
export * from "./programadoAtendido.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports